class DistribFaqsMobileAccordion {
  constructor () {
    this.init()
  }

  init () {
    const accordions = document.querySelectorAll('.c-distrib_faqs')

    if (!accordions) return
    accordions.forEach((accordion) => {
      const openCloseButton = accordion.querySelector('.c-distrib_faqs__toggleAll')
      const accordionItems = accordion.querySelectorAll('.c-distrib_faqs__item')

      if (!openCloseButton || !accordionItems) return
      openCloseButton.addEventListener('click', () => {
        if (openCloseButton.classList.contains('hasAllOpened')) {
          accordionItems.forEach(item => {
            item.classList.remove('isOpen')
          })
          openCloseButton.classList.remove('hasAllOpened')
          openCloseButton.classList.add('hasAllClosed')
        } else {
          accordionItems.forEach(item => {
            item.classList.add('isOpen')
            openCloseButton.classList.remove('hasAllClosed')
            openCloseButton.classList.add('hasAllOpened')
          })
        }
      })

      accordionItems.forEach(item => {
        item.classList.remove('isOpen')
        item.addEventListener('click', () => {
          item.classList.toggle('isOpen')
        })
      })
    })
  }
}

export default DistribFaqsMobileAccordion
